import styled from 'styled-components';
import Text14 from '@sdk/components/ui/typography/Text14';

import EditGraySvg from '@web/assets/svg/UI/pencil.svg';

export const BillingInfoSectionContainer = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const BillingInfoRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const BillingInfoHeader = styled(BillingInfoRow)`
  padding-bottom: 5px;
  border-bottom: 1px solid ${(props) => props.theme.colors.separatorOnWhite};
`;

export const EditIcon = styled(EditGraySvg)`
  cursor: pointer;
  path {
    fill: ${({ theme }) => theme.colors.iconGray};
  }
`;

export const BillingInfoText = styled(Text14)`
  color: ${(props) => props.theme.colors.gray};
`;

export const BillingAddressLabel = styled(Text14)`
  color: ${(props) => props.theme.colors.gray};
  white-space: break-spaces;
  text-align: end;
`;
